// extracted by mini-css-extract-plugin
module.exports = {"BooksMenu":"BooksMenu_BooksMenu__k8MJV","BooksMenu__MenuDetail":"BooksMenu_BooksMenu__MenuDetail__rd4JV","BooksMenu__Time":"BooksMenu_BooksMenu__Time__1Mfvw"};